<template>
  <modal :visible='visible' @close='visible=false'>
    <div class="content content-y">
      <span class="exit" @click="visible=false"><span class="close absolute"> </span></span>
      <div class="flex flex-reactive body stretch">
        <div class="skills" 
          v-for="skill in skills" :key="skill.title">
          <div class="flex stretch skill">
            <h3 class="title">{{skill.title}}</h3>
            <div class="scroll">
                <ul class="topics">
                  <li class="topic" v-for="topic in skill.topics" :key="topic"> {{topic}} </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
  </modal>
</template>

<script>
import modal from '@/components/structure/Modal.vue'

export default {
  name: 'SkillsModal',
  components: {
    modal
  },
  data() {
    return {
      visible: false,
      skills: [
        {
          title: 'Programming',
          topics: [
            'C# / Java',
            'C / C++',
            'Python / Lua',
            'HTML / CSS',
            'Node.js / PHP',
            'Javascript / VueJS',
            'Cg / HLSL',
            'OpenCV / Keras',
          ]
        },
        {
          title: 'Design',
          topics: [
            'Affinity Photo',
            'Affinity Designer', 
            'Blender',
            'Aseprite',
            ]
        },
        {
          title: 'Technologies',
          topics: [
            'Unity',
            'Docker',
            'Git',
            'Android',
            'Linux',
            'Windows',
            ]
        },
      ]
    }
  },
  watch: {
    data(a,b){
      if(a != null)
        this.visible=true
    }
  },
  methods: {
    open() {
      this.visible = true;
    }
  }

}
</script>

<style scoped>

.media{
  width: 100%;
}

.skill{
  max-height: 100%;
}

li::marker{
  content: '-';
  font-weight: bold;
  margin-right: 0.5em;
}

.inherit{
  max-height: inherit;
}

.media{
  border-width: 0px;
}

.flex.content-small-y{
  overflow-y: auto;
  justify-content: start;
}

.skills{
  max-height: inherit;
  overflow: hidden;
  flex: 1;
}

.skills *{
  text-align: center;
}

h3.title{
  margin-top: 1em;
  color: white;
}

.topics {
  width: max-content;
  flex: 1;
}


.topic {
  text-align: left;
}

.topic, .skills *{
  color: var(--bright-color);
  font-family: 'OpenSans';
  font-weight: normal;
}

.content{
  color: white;
  min-width: 50%;
  z-index: 20;
  background-color: var(--dark-color);
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  position: relative;
}

.exit{
  cursor: pointer;
  position: absolute;
  right: 0px;
  width: 30px;
  height: 30px;
  opacity: 0.9;
  background-color: var(--bright-color);
  border-radius: 50%;
  z-index: 10;
}

.close{
  position: absolute;
  right: 0px;
  border-radius: 50%;
  overflow: hidden;
  opacity: 0.5;
  width: 70%;
  height: 70%;
  left: 15%;
  top: 15%;
}
.close::before,
.close::after{
  content: '';
  position: absolute;
  border-width: 3px;
  border-style: solid;
  border-color: black;
  top: 0%;
  left: 0%;
  bottom: 0%;
  right: 0%;
  transform: rotate(45deg) translate(50%,50%) scale(1.1, 1.1);
}
.close::after{
  transform: rotate(45deg) translate(-50%,-50%) scale(1.1,1.1);
}

.body{
  height: 100%;
  padding: 1em;
  max-height: inherit;
  flex: 1;
}

.body *{
  padding: 0;
}

.justify{
  justify-content: flex-end;
  align-items: stretch;
}

.slides{
  padding: 0;
}

@media screen and (min-width:1408px){
  .content{
    width: 50%;
  }
  .content-y, .content-small-y{
    max-height: 50vh;
    height: 50vh;
  }
}

@media screen and (max-width:1407px){
  .content{
    width: 70%;
  }
  .content-y, .content-small-y{
    max-height: 50vh;
    height: 50vh;
  }
}



@media screen and (max-width:1023px){
  .content{
    width: 70%;
  }
  .content-y{
    max-height: 60vh;
    height: 60vh;
  }
  .content-small-y{
    max-height: 30vh;
    height: 30vh;
  }
  .slides {
    height: 30vh;
  }
}

@media screen and (max-width:768px){
  .content{
    width: 90%;
    max-height: 90vh;
    height: 90vh;
  }
  .content-y{
    max-height: 90vh;
    height: 90vh;
  }
  .content-small-y{
    max-height: 40vh;
  }
  .slides {
    height: 30vh;
  }
}


div.title{
  margin: 0.4em;
  color: white;
  font-family: 'OpenSans';
  flex:none;
  font-weight: normal;
  text-align: left;
}

</style>

